
  <section class="page-banner-sec" [style.background-image]="'url(' + (pageData?.image ? pageData?.image  :'assets/img/safety-page-banner.png') + ')'">
    <div class="container">
        <h1 class="page-banner-title" [innerText]="pageData?.title"></h1>
    </div>
  </section>

  <section class="py-5">
     <div class="container">

         <div class="row two-part-img-text">
             <div class="col-lg-6"><div class="part-img">
                 <img [src]="pageData?.jsonKey[0]?.content[0]?.image? pageData?.jsonKey[0]?.content[0]?.image:'assets/img/safety-commitment.png'" class="img-responsive">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="part-text">
                    <h2 class="font-weight-bold" [innerText]="pageData?.jsonKey[0]?.content[0]?.title"></h2>
                   <p [innerText]="pageData?.jsonKey[0]?.content[0]?.description"></p>
                     </div>
            </div>
        </div>
     </div>
  </section>

  <section class="pt-5 safety-feachers-sec">
     <div class="container">
        <div class="row two-part-img-text align-items-center">

           <div class="col-lg-6">
               <div class="part-text my-4">
                    <h2 class="font-weight-bold" [innerText]="pageData?.jsonKey[0]?.content[1]?.title"></h2>

                    <p [innerText]="pageData?.jsonKey[0]?.content[1]?.description"></p>
                    
                    <a class="mr-3" href="javascript:void(0);"><img src="assets/img/btn-appstore.png"></a>
                    <a href="javascript:void(0);"><img src="assets/img/btn-playstore.png"></a>
               </div>
           </div>
           <div class="col-lg-6"><div class="part-img">
            <img [src]="pageData?.jsonKey[0]?.content[1]?.image? pageData?.jsonKey[0]?.content[1]?.image:'assets/img/iphone-in-hand.png'" class="img-responsive">
           </div>
       </div>
       </div>

     </div>
  </section>

  <section class="py-5 safety-theme-sec">
      <div class="container">
        <div class="row two-part-img-text mb-4">
            <div class="col-lg-6 my-3"><div class="part-img">
                <img [src]="pageData?.jsonKey[0]?.content[2]?.image? pageData?.jsonKey[0]?.content[2]?.image:'assets/img/driver-safety.png'" class="img-responsive">
               </div>
           </div>
           <div class="col-lg-6 my-3">
               <div class="part-text">
                    <h2 class="font-weight-bold" [innerText]="pageData?.jsonKey[0]?.content[2]?.title"></h2>
                <p [innerText]="pageData?.jsonKey[0]?.content[2]?.description"></p>
               </div>
           </div>
       </div>
       <div class="row flex-lg-row-reverse two-part-img-text">
        <div class="col-lg-6 my-2"><div class="part-img">
            <img [src]="pageData?.jsonKey[0]?.content[3]?.image? pageData?.jsonKey[0]?.content[3]?.image:'assets/img/rider-safety.png'" class="img-responsive">
           </div>
       </div>
       <div class="col-lg-6 my-2">
           <div class="part-text">
                    <h2 class="font-weight-bold" [innerText]="pageData?.jsonKey[0]?.content[3]?.title"></h2>
          <p [innerText]="pageData?.jsonKey[0]?.content[3]?.description"></p>
           </div>
       </div>
   </div>
      </div>
  </section>

